/**
 * Parses profit time stored in hours into displayable components.
 * Backend stores profit durations in hours (e.g., 0.167 = 10 minutes).
 */
export interface ProfitTimeResult {
  hours: number // Full hours (e.g., 1 for 1 hour)
  minutes: number // Total minutes (e.g., 10 for 10 minutes)
  displayInHours: boolean // true if >= 60 minutes
}

export function parseProfitHours(hours: number): ProfitTimeResult {
  const totalMinutes = Math.floor(hours * 60)
  return {
    hours: Math.floor(hours),
    minutes: totalMinutes,
    displayInHours: totalMinutes >= 60,
  }
}

/**
 * Formats profit hours to a short display string.
 * Examples: 0.167 → "10min", 1 → "1H", 1.5 → "1H"
 */
export function formatProfitTime(hours: number): string {
  const { hours: h, minutes, displayInHours } = parseProfitHours(hours)
  return displayInHours ? `${h}H` : `${minutes}min`
}
